// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/payment_api.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { CreditsPackage, PackageIdentity, PremiumPackage } from "./package_pb.js";
import { BillingHistoryItem, OrderStatus, PaymentCard, PaymentGateway, PaymentMethod, PaymentMethodType, PaymentOrderStatusDetails } from "./payment_pb.js";
import { Subscription } from "./subscription_pb.js";
import { Booster } from "./booster_pb.js";
import { PromoType } from "./promo_pb.js";
import { FeatureType } from "../../../../market/v1/package_pb.js";

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPackageRequest
 */
export class GetPackageRequest extends Message<GetPackageRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 1;
   */
  package?: PackageIdentity;

  constructor(data?: PartialMessage<GetPackageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPackageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package", kind: "message", T: PackageIdentity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPackageRequest {
    return new GetPackageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPackageRequest {
    return new GetPackageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPackageRequest {
    return new GetPackageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPackageRequest | PlainMessage<GetPackageRequest> | undefined, b: GetPackageRequest | PlainMessage<GetPackageRequest> | undefined): boolean {
    return proto3.util.equals(GetPackageRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPackageResponse
 */
export class GetPackageResponse extends Message<GetPackageResponse> {
  /**
   * @generated from oneof gdx.gateway.web.payment.v2.GetPackageResponse.package
   */
  package: {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PremiumPackage premium = 1;
     */
    value: PremiumPackage;
    case: "premium";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.CreditsPackage credits = 2;
     */
    value: CreditsPackage;
    case: "credits";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetPackageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPackageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "premium", kind: "message", T: PremiumPackage, oneof: "package" },
    { no: 2, name: "credits", kind: "message", T: CreditsPackage, oneof: "package" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPackageResponse {
    return new GetPackageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPackageResponse {
    return new GetPackageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPackageResponse {
    return new GetPackageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPackageResponse | PlainMessage<GetPackageResponse> | undefined, b: GetPackageResponse | PlainMessage<GetPackageResponse> | undefined): boolean {
    return proto3.util.equals(GetPackageResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListSuspensionPeriodsRequest
 */
export class ListSuspensionPeriodsRequest extends Message<ListSuspensionPeriodsRequest> {
  constructor(data?: PartialMessage<ListSuspensionPeriodsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListSuspensionPeriodsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSuspensionPeriodsRequest {
    return new ListSuspensionPeriodsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsRequest {
    return new ListSuspensionPeriodsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsRequest {
    return new ListSuspensionPeriodsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSuspensionPeriodsRequest | PlainMessage<ListSuspensionPeriodsRequest> | undefined, b: ListSuspensionPeriodsRequest | PlainMessage<ListSuspensionPeriodsRequest> | undefined): boolean {
    return proto3.util.equals(ListSuspensionPeriodsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListSuspensionPeriodsResponse
 */
export class ListSuspensionPeriodsResponse extends Message<ListSuspensionPeriodsResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.ListSuspensionPeriodsResponse.Period periods = 1;
   */
  periods: ListSuspensionPeriodsResponse_Period[] = [];

  constructor(data?: PartialMessage<ListSuspensionPeriodsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListSuspensionPeriodsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "periods", kind: "message", T: ListSuspensionPeriodsResponse_Period, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSuspensionPeriodsResponse {
    return new ListSuspensionPeriodsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsResponse {
    return new ListSuspensionPeriodsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsResponse {
    return new ListSuspensionPeriodsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSuspensionPeriodsResponse | PlainMessage<ListSuspensionPeriodsResponse> | undefined, b: ListSuspensionPeriodsResponse | PlainMessage<ListSuspensionPeriodsResponse> | undefined): boolean {
    return proto3.util.equals(ListSuspensionPeriodsResponse, a, b);
  }
}

/**
 * Describes suspension period.
 *
 * @generated from message gdx.gateway.web.payment.v2.ListSuspensionPeriodsResponse.Period
 */
export class ListSuspensionPeriodsResponse_Period extends Message<ListSuspensionPeriodsResponse_Period> {
  /**
   * @generated from field: google.protobuf.Duration suspension_duration = 1;
   */
  suspensionDuration?: Duration;

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  constructor(data?: PartialMessage<ListSuspensionPeriodsResponse_Period>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListSuspensionPeriodsResponse.Period";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "suspension_duration", kind: "message", T: Duration },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSuspensionPeriodsResponse_Period {
    return new ListSuspensionPeriodsResponse_Period().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsResponse_Period {
    return new ListSuspensionPeriodsResponse_Period().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSuspensionPeriodsResponse_Period {
    return new ListSuspensionPeriodsResponse_Period().fromJsonString(jsonString, options);
  }

  static equals(a: ListSuspensionPeriodsResponse_Period | PlainMessage<ListSuspensionPeriodsResponse_Period> | undefined, b: ListSuspensionPeriodsResponse_Period | PlainMessage<ListSuspensionPeriodsResponse_Period> | undefined): boolean {
    return proto3.util.equals(ListSuspensionPeriodsResponse_Period, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetRecommendedSubscriptionPackageRequest
 */
export class GetRecommendedSubscriptionPackageRequest extends Message<GetRecommendedSubscriptionPackageRequest> {
  constructor(data?: PartialMessage<GetRecommendedSubscriptionPackageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetRecommendedSubscriptionPackageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRecommendedSubscriptionPackageRequest {
    return new GetRecommendedSubscriptionPackageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRecommendedSubscriptionPackageRequest {
    return new GetRecommendedSubscriptionPackageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRecommendedSubscriptionPackageRequest {
    return new GetRecommendedSubscriptionPackageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRecommendedSubscriptionPackageRequest | PlainMessage<GetRecommendedSubscriptionPackageRequest> | undefined, b: GetRecommendedSubscriptionPackageRequest | PlainMessage<GetRecommendedSubscriptionPackageRequest> | undefined): boolean {
    return proto3.util.equals(GetRecommendedSubscriptionPackageRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetRecommendedSubscriptionPackageResponse
 */
export class GetRecommendedSubscriptionPackageResponse extends Message<GetRecommendedSubscriptionPackageResponse> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PremiumPackage recommended_package = 1;
   */
  recommendedPackage?: PremiumPackage;

  constructor(data?: PartialMessage<GetRecommendedSubscriptionPackageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetRecommendedSubscriptionPackageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "recommended_package", kind: "message", T: PremiumPackage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRecommendedSubscriptionPackageResponse {
    return new GetRecommendedSubscriptionPackageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRecommendedSubscriptionPackageResponse {
    return new GetRecommendedSubscriptionPackageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRecommendedSubscriptionPackageResponse {
    return new GetRecommendedSubscriptionPackageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRecommendedSubscriptionPackageResponse | PlainMessage<GetRecommendedSubscriptionPackageResponse> | undefined, b: GetRecommendedSubscriptionPackageResponse | PlainMessage<GetRecommendedSubscriptionPackageResponse> | undefined): boolean {
    return proto3.util.equals(GetRecommendedSubscriptionPackageResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.CompleteOffersRequest
 */
export class CompleteOffersRequest extends Message<CompleteOffersRequest> {
  /**
   * @generated from field: repeated string completed_offer_ids = 1;
   */
  completedOfferIds: string[] = [];

  constructor(data?: PartialMessage<CompleteOffersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.CompleteOffersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "completed_offer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteOffersRequest {
    return new CompleteOffersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteOffersRequest {
    return new CompleteOffersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteOffersRequest {
    return new CompleteOffersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteOffersRequest | PlainMessage<CompleteOffersRequest> | undefined, b: CompleteOffersRequest | PlainMessage<CompleteOffersRequest> | undefined): boolean {
    return proto3.util.equals(CompleteOffersRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.CompleteOffersResponse
 */
export class CompleteOffersResponse extends Message<CompleteOffersResponse> {
  /**
   * @generated from field: repeated string assigned_offer_ids = 1;
   */
  assignedOfferIds: string[] = [];

  constructor(data?: PartialMessage<CompleteOffersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.CompleteOffersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assigned_offer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompleteOffersResponse {
    return new CompleteOffersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompleteOffersResponse {
    return new CompleteOffersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompleteOffersResponse {
    return new CompleteOffersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CompleteOffersResponse | PlainMessage<CompleteOffersResponse> | undefined, b: CompleteOffersResponse | PlainMessage<CompleteOffersResponse> | undefined): boolean {
    return proto3.util.equals(CompleteOffersResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPackagesRequest
 */
export class ListPackagesRequest extends Message<ListPackagesRequest> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PackageIdentity packages = 1;
   */
  packages: PackageIdentity[] = [];

  constructor(data?: PartialMessage<ListPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "packages", kind: "message", T: PackageIdentity, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPackagesRequest {
    return new ListPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPackagesRequest {
    return new ListPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPackagesRequest {
    return new ListPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPackagesRequest | PlainMessage<ListPackagesRequest> | undefined, b: ListPackagesRequest | PlainMessage<ListPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPackagesResponse
 */
export class ListPackagesResponse extends Message<ListPackagesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage premium_packages = 1;
   */
  premiumPackages: PremiumPackage[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.CreditsPackage credit_packages = 2;
   */
  creditPackages: CreditsPackage[] = [];

  constructor(data?: PartialMessage<ListPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "premium_packages", kind: "message", T: PremiumPackage, repeated: true },
    { no: 2, name: "credit_packages", kind: "message", T: CreditsPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPackagesResponse {
    return new ListPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPackagesResponse {
    return new ListPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPackagesResponse {
    return new ListPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPackagesResponse | PlainMessage<ListPackagesResponse> | undefined, b: ListPackagesResponse | PlainMessage<ListPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SuspendSubscriptionRequest
 */
export class SuspendSubscriptionRequest extends Message<SuspendSubscriptionRequest> {
  /**
   * @generated from field: google.protobuf.Duration until_duration = 1;
   */
  untilDuration?: Duration;

  constructor(data?: PartialMessage<SuspendSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SuspendSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "until_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuspendSubscriptionRequest {
    return new SuspendSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuspendSubscriptionRequest {
    return new SuspendSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuspendSubscriptionRequest {
    return new SuspendSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SuspendSubscriptionRequest | PlainMessage<SuspendSubscriptionRequest> | undefined, b: SuspendSubscriptionRequest | PlainMessage<SuspendSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(SuspendSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SuspendSubscriptionResponse
 */
export class SuspendSubscriptionResponse extends Message<SuspendSubscriptionResponse> {
  constructor(data?: PartialMessage<SuspendSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SuspendSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuspendSubscriptionResponse {
    return new SuspendSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuspendSubscriptionResponse {
    return new SuspendSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuspendSubscriptionResponse {
    return new SuspendSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SuspendSubscriptionResponse | PlainMessage<SuspendSubscriptionResponse> | undefined, b: SuspendSubscriptionResponse | PlainMessage<SuspendSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(SuspendSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ActivateSubscriptionRequest
 */
export class ActivateSubscriptionRequest extends Message<ActivateSubscriptionRequest> {
  constructor(data?: PartialMessage<ActivateSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ActivateSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateSubscriptionRequest {
    return new ActivateSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateSubscriptionRequest {
    return new ActivateSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateSubscriptionRequest {
    return new ActivateSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateSubscriptionRequest | PlainMessage<ActivateSubscriptionRequest> | undefined, b: ActivateSubscriptionRequest | PlainMessage<ActivateSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(ActivateSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ActivateSubscriptionResponse
 */
export class ActivateSubscriptionResponse extends Message<ActivateSubscriptionResponse> {
  constructor(data?: PartialMessage<ActivateSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ActivateSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateSubscriptionResponse {
    return new ActivateSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateSubscriptionResponse {
    return new ActivateSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateSubscriptionResponse {
    return new ActivateSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateSubscriptionResponse | PlainMessage<ActivateSubscriptionResponse> | undefined, b: ActivateSubscriptionResponse | PlainMessage<ActivateSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(ActivateSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.InitiatePayPalPaymentRequest
 */
export class InitiatePayPalPaymentRequest extends Message<InitiatePayPalPaymentRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 1;
   */
  package?: PackageIdentity;

  constructor(data?: PartialMessage<InitiatePayPalPaymentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.InitiatePayPalPaymentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package", kind: "message", T: PackageIdentity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitiatePayPalPaymentRequest {
    return new InitiatePayPalPaymentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitiatePayPalPaymentRequest {
    return new InitiatePayPalPaymentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitiatePayPalPaymentRequest {
    return new InitiatePayPalPaymentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitiatePayPalPaymentRequest | PlainMessage<InitiatePayPalPaymentRequest> | undefined, b: InitiatePayPalPaymentRequest | PlainMessage<InitiatePayPalPaymentRequest> | undefined): boolean {
    return proto3.util.equals(InitiatePayPalPaymentRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.InitiatePayPalPaymentResponse
 */
export class InitiatePayPalPaymentResponse extends Message<InitiatePayPalPaymentResponse> {
  /**
   * @generated from field: string script_url = 1;
   */
  scriptUrl = "";

  constructor(data?: PartialMessage<InitiatePayPalPaymentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.InitiatePayPalPaymentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "script_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitiatePayPalPaymentResponse {
    return new InitiatePayPalPaymentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitiatePayPalPaymentResponse {
    return new InitiatePayPalPaymentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitiatePayPalPaymentResponse {
    return new InitiatePayPalPaymentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitiatePayPalPaymentResponse | PlainMessage<InitiatePayPalPaymentResponse> | undefined, b: InitiatePayPalPaymentResponse | PlainMessage<InitiatePayPalPaymentResponse> | undefined): boolean {
    return proto3.util.equals(InitiatePayPalPaymentResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPaymentOrderStatusRequest
 */
export class GetPaymentOrderStatusRequest extends Message<GetPaymentOrderStatusRequest> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  constructor(data?: PartialMessage<GetPaymentOrderStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPaymentOrderStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentOrderStatusRequest {
    return new GetPaymentOrderStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentOrderStatusRequest {
    return new GetPaymentOrderStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentOrderStatusRequest {
    return new GetPaymentOrderStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentOrderStatusRequest | PlainMessage<GetPaymentOrderStatusRequest> | undefined, b: GetPaymentOrderStatusRequest | PlainMessage<GetPaymentOrderStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetPaymentOrderStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPaymentOrderStatusResponse
 */
export class GetPaymentOrderStatusResponse extends Message<GetPaymentOrderStatusResponse> {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentOrderStatusDetails status_details = 2;
   */
  statusDetails?: PaymentOrderStatusDetails;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.OrderStatus prev_status = 3;
   */
  prevStatus = OrderStatus.ORDER_STATUS_INVALID;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentGateway gateway = 4;
   */
  gateway = PaymentGateway.INVALID;

  constructor(data?: PartialMessage<GetPaymentOrderStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPaymentOrderStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status_details", kind: "message", T: PaymentOrderStatusDetails },
    { no: 3, name: "prev_status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 4, name: "gateway", kind: "enum", T: proto3.getEnumType(PaymentGateway) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentOrderStatusResponse {
    return new GetPaymentOrderStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentOrderStatusResponse {
    return new GetPaymentOrderStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentOrderStatusResponse {
    return new GetPaymentOrderStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentOrderStatusResponse | PlainMessage<GetPaymentOrderStatusResponse> | undefined, b: GetPaymentOrderStatusResponse | PlainMessage<GetPaymentOrderStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetPaymentOrderStatusResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ApplyFreePackageRequest
 */
export class ApplyFreePackageRequest extends Message<ApplyFreePackageRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 1;
   */
  package?: PackageIdentity;

  /**
   * @generated from field: string payment_source = 2;
   */
  paymentSource = "";

  constructor(data?: PartialMessage<ApplyFreePackageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ApplyFreePackageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package", kind: "message", T: PackageIdentity },
    { no: 2, name: "payment_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyFreePackageRequest {
    return new ApplyFreePackageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyFreePackageRequest {
    return new ApplyFreePackageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyFreePackageRequest {
    return new ApplyFreePackageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyFreePackageRequest | PlainMessage<ApplyFreePackageRequest> | undefined, b: ApplyFreePackageRequest | PlainMessage<ApplyFreePackageRequest> | undefined): boolean {
    return proto3.util.equals(ApplyFreePackageRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ApplyFreePackageResponse
 */
export class ApplyFreePackageResponse extends Message<ApplyFreePackageResponse> {
  constructor(data?: PartialMessage<ApplyFreePackageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ApplyFreePackageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplyFreePackageResponse {
    return new ApplyFreePackageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplyFreePackageResponse {
    return new ApplyFreePackageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplyFreePackageResponse {
    return new ApplyFreePackageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ApplyFreePackageResponse | PlainMessage<ApplyFreePackageResponse> | undefined, b: ApplyFreePackageResponse | PlainMessage<ApplyFreePackageResponse> | undefined): boolean {
    return proto3.util.equals(ApplyFreePackageResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPaymentCardsRequest
 */
export class ListPaymentCardsRequest extends Message<ListPaymentCardsRequest> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PaymentGateway gateways = 1;
   */
  gateways: PaymentGateway[] = [];

  constructor(data?: PartialMessage<ListPaymentCardsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPaymentCardsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gateways", kind: "enum", T: proto3.getEnumType(PaymentGateway), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPaymentCardsRequest {
    return new ListPaymentCardsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPaymentCardsRequest {
    return new ListPaymentCardsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPaymentCardsRequest {
    return new ListPaymentCardsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPaymentCardsRequest | PlainMessage<ListPaymentCardsRequest> | undefined, b: ListPaymentCardsRequest | PlainMessage<ListPaymentCardsRequest> | undefined): boolean {
    return proto3.util.equals(ListPaymentCardsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPaymentCardsResponse
 */
export class ListPaymentCardsResponse extends Message<ListPaymentCardsResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PaymentCard cards = 1;
   */
  cards: PaymentCard[] = [];

  constructor(data?: PartialMessage<ListPaymentCardsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPaymentCardsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cards", kind: "message", T: PaymentCard, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPaymentCardsResponse {
    return new ListPaymentCardsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPaymentCardsResponse {
    return new ListPaymentCardsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPaymentCardsResponse {
    return new ListPaymentCardsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPaymentCardsResponse | PlainMessage<ListPaymentCardsResponse> | undefined, b: ListPaymentCardsResponse | PlainMessage<ListPaymentCardsResponse> | undefined): boolean {
    return proto3.util.equals(ListPaymentCardsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.RemovePaymentCardRequest
 */
export class RemovePaymentCardRequest extends Message<RemovePaymentCardRequest> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  constructor(data?: PartialMessage<RemovePaymentCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.RemovePaymentCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemovePaymentCardRequest {
    return new RemovePaymentCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemovePaymentCardRequest {
    return new RemovePaymentCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemovePaymentCardRequest {
    return new RemovePaymentCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RemovePaymentCardRequest | PlainMessage<RemovePaymentCardRequest> | undefined, b: RemovePaymentCardRequest | PlainMessage<RemovePaymentCardRequest> | undefined): boolean {
    return proto3.util.equals(RemovePaymentCardRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.RemovePaymentCardResponse
 */
export class RemovePaymentCardResponse extends Message<RemovePaymentCardResponse> {
  constructor(data?: PartialMessage<RemovePaymentCardResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.RemovePaymentCardResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemovePaymentCardResponse {
    return new RemovePaymentCardResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemovePaymentCardResponse {
    return new RemovePaymentCardResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemovePaymentCardResponse {
    return new RemovePaymentCardResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RemovePaymentCardResponse | PlainMessage<RemovePaymentCardResponse> | undefined, b: RemovePaymentCardResponse | PlainMessage<RemovePaymentCardResponse> | undefined): boolean {
    return proto3.util.equals(RemovePaymentCardResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSolidAuthorizeFormRequest
 */
export class GetSolidAuthorizeFormRequest extends Message<GetSolidAuthorizeFormRequest> {
  /**
   * @generated from field: string payment_source = 1;
   */
  paymentSource = "";

  constructor(data?: PartialMessage<GetSolidAuthorizeFormRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSolidAuthorizeFormRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSolidAuthorizeFormRequest {
    return new GetSolidAuthorizeFormRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSolidAuthorizeFormRequest {
    return new GetSolidAuthorizeFormRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSolidAuthorizeFormRequest {
    return new GetSolidAuthorizeFormRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSolidAuthorizeFormRequest | PlainMessage<GetSolidAuthorizeFormRequest> | undefined, b: GetSolidAuthorizeFormRequest | PlainMessage<GetSolidAuthorizeFormRequest> | undefined): boolean {
    return proto3.util.equals(GetSolidAuthorizeFormRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSolidAuthorizeFormResponse
 */
export class GetSolidAuthorizeFormResponse extends Message<GetSolidAuthorizeFormResponse> {
  /**
   * @generated from field: string merchant = 1;
   */
  merchant = "";

  /**
   * @generated from field: string signature = 2;
   */
  signature = "";

  /**
   * @generated from field: string payment_intent = 3;
   */
  paymentIntent = "";

  constructor(data?: PartialMessage<GetSolidAuthorizeFormResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSolidAuthorizeFormResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "merchant", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_intent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSolidAuthorizeFormResponse {
    return new GetSolidAuthorizeFormResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSolidAuthorizeFormResponse {
    return new GetSolidAuthorizeFormResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSolidAuthorizeFormResponse {
    return new GetSolidAuthorizeFormResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSolidAuthorizeFormResponse | PlainMessage<GetSolidAuthorizeFormResponse> | undefined, b: GetSolidAuthorizeFormResponse | PlainMessage<GetSolidAuthorizeFormResponse> | undefined): boolean {
    return proto3.util.equals(GetSolidAuthorizeFormResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSubscriptionStatusRequest
 */
export class GetSubscriptionStatusRequest extends Message<GetSubscriptionStatusRequest> {
  constructor(data?: PartialMessage<GetSubscriptionStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSubscriptionStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubscriptionStatusRequest {
    return new GetSubscriptionStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubscriptionStatusRequest {
    return new GetSubscriptionStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubscriptionStatusRequest {
    return new GetSubscriptionStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubscriptionStatusRequest | PlainMessage<GetSubscriptionStatusRequest> | undefined, b: GetSubscriptionStatusRequest | PlainMessage<GetSubscriptionStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetSubscriptionStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSubscriptionStatusResponse
 */
export class GetSubscriptionStatusResponse extends Message<GetSubscriptionStatusResponse> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.Subscription subscription = 1;
   */
  subscription?: Subscription;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PremiumPackage current_package = 2;
   */
  currentPackage?: PremiumPackage;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PremiumPackage next_package = 3;
   */
  nextPackage?: PremiumPackage;

  constructor(data?: PartialMessage<GetSubscriptionStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSubscriptionStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
    { no: 2, name: "current_package", kind: "message", T: PremiumPackage },
    { no: 3, name: "next_package", kind: "message", T: PremiumPackage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSubscriptionStatusResponse {
    return new GetSubscriptionStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSubscriptionStatusResponse {
    return new GetSubscriptionStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSubscriptionStatusResponse {
    return new GetSubscriptionStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSubscriptionStatusResponse | PlainMessage<GetSubscriptionStatusResponse> | undefined, b: GetSubscriptionStatusResponse | PlainMessage<GetSubscriptionStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetSubscriptionStatusResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPremiumPackagesRequest
 */
export class ListPremiumPackagesRequest extends Message<ListPremiumPackagesRequest> {
  constructor(data?: PartialMessage<ListPremiumPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPremiumPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPremiumPackagesRequest {
    return new ListPremiumPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPremiumPackagesRequest {
    return new ListPremiumPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPremiumPackagesRequest {
    return new ListPremiumPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPremiumPackagesRequest | PlainMessage<ListPremiumPackagesRequest> | undefined, b: ListPremiumPackagesRequest | PlainMessage<ListPremiumPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListPremiumPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPremiumPackagesResponse
 */
export class ListPremiumPackagesResponse extends Message<ListPremiumPackagesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage packages = 1;
   */
  packages: PremiumPackage[] = [];

  constructor(data?: PartialMessage<ListPremiumPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPremiumPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "packages", kind: "message", T: PremiumPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPremiumPackagesResponse {
    return new ListPremiumPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPremiumPackagesResponse {
    return new ListPremiumPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPremiumPackagesResponse {
    return new ListPremiumPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPremiumPackagesResponse | PlainMessage<ListPremiumPackagesResponse> | undefined, b: ListPremiumPackagesResponse | PlainMessage<ListPremiumPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListPremiumPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPremiumGoldPackagesRequest
 */
export class ListPremiumGoldPackagesRequest extends Message<ListPremiumGoldPackagesRequest> {
  constructor(data?: PartialMessage<ListPremiumGoldPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPremiumGoldPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPremiumGoldPackagesRequest {
    return new ListPremiumGoldPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPremiumGoldPackagesRequest {
    return new ListPremiumGoldPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPremiumGoldPackagesRequest {
    return new ListPremiumGoldPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPremiumGoldPackagesRequest | PlainMessage<ListPremiumGoldPackagesRequest> | undefined, b: ListPremiumGoldPackagesRequest | PlainMessage<ListPremiumGoldPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListPremiumGoldPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPremiumGoldPackagesResponse
 */
export class ListPremiumGoldPackagesResponse extends Message<ListPremiumGoldPackagesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage packages = 1;
   */
  packages: PremiumPackage[] = [];

  constructor(data?: PartialMessage<ListPremiumGoldPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPremiumGoldPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "packages", kind: "message", T: PremiumPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPremiumGoldPackagesResponse {
    return new ListPremiumGoldPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPremiumGoldPackagesResponse {
    return new ListPremiumGoldPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPremiumGoldPackagesResponse {
    return new ListPremiumGoldPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPremiumGoldPackagesResponse | PlainMessage<ListPremiumGoldPackagesResponse> | undefined, b: ListPremiumGoldPackagesResponse | PlainMessage<ListPremiumGoldPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListPremiumGoldPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListCreditsPackagesRequest
 */
export class ListCreditsPackagesRequest extends Message<ListCreditsPackagesRequest> {
  constructor(data?: PartialMessage<ListCreditsPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListCreditsPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCreditsPackagesRequest {
    return new ListCreditsPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCreditsPackagesRequest {
    return new ListCreditsPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCreditsPackagesRequest {
    return new ListCreditsPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCreditsPackagesRequest | PlainMessage<ListCreditsPackagesRequest> | undefined, b: ListCreditsPackagesRequest | PlainMessage<ListCreditsPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListCreditsPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListCreditsPackagesResponse
 */
export class ListCreditsPackagesResponse extends Message<ListCreditsPackagesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.CreditsPackage packages = 1;
   */
  packages: CreditsPackage[] = [];

  constructor(data?: PartialMessage<ListCreditsPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListCreditsPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "packages", kind: "message", T: CreditsPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCreditsPackagesResponse {
    return new ListCreditsPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCreditsPackagesResponse {
    return new ListCreditsPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCreditsPackagesResponse {
    return new ListCreditsPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCreditsPackagesResponse | PlainMessage<ListCreditsPackagesResponse> | undefined, b: ListCreditsPackagesResponse | PlainMessage<ListCreditsPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListCreditsPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListBoostersRequest
 */
export class ListBoostersRequest extends Message<ListBoostersRequest> {
  constructor(data?: PartialMessage<ListBoostersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListBoostersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBoostersRequest {
    return new ListBoostersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBoostersRequest {
    return new ListBoostersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBoostersRequest {
    return new ListBoostersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListBoostersRequest | PlainMessage<ListBoostersRequest> | undefined, b: ListBoostersRequest | PlainMessage<ListBoostersRequest> | undefined): boolean {
    return proto3.util.equals(ListBoostersRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListBoostersResponse
 */
export class ListBoostersResponse extends Message<ListBoostersResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.Booster boosters = 1;
   */
  boosters: Booster[] = [];

  constructor(data?: PartialMessage<ListBoostersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListBoostersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boosters", kind: "message", T: Booster, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBoostersResponse {
    return new ListBoostersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBoostersResponse {
    return new ListBoostersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBoostersResponse {
    return new ListBoostersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListBoostersResponse | PlainMessage<ListBoostersResponse> | undefined, b: ListBoostersResponse | PlainMessage<ListBoostersResponse> | undefined): boolean {
    return proto3.util.equals(ListBoostersResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ActivateBoosterRequest
 */
export class ActivateBoosterRequest extends Message<ActivateBoosterRequest> {
  /**
   * @generated from field: string booster_id = 1;
   */
  boosterId = "";

  constructor(data?: PartialMessage<ActivateBoosterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ActivateBoosterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "booster_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateBoosterRequest {
    return new ActivateBoosterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateBoosterRequest {
    return new ActivateBoosterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateBoosterRequest {
    return new ActivateBoosterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateBoosterRequest | PlainMessage<ActivateBoosterRequest> | undefined, b: ActivateBoosterRequest | PlainMessage<ActivateBoosterRequest> | undefined): boolean {
    return proto3.util.equals(ActivateBoosterRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ActivateBoosterResponse
 */
export class ActivateBoosterResponse extends Message<ActivateBoosterResponse> {
  constructor(data?: PartialMessage<ActivateBoosterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ActivateBoosterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateBoosterResponse {
    return new ActivateBoosterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateBoosterResponse {
    return new ActivateBoosterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateBoosterResponse {
    return new ActivateBoosterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateBoosterResponse | PlainMessage<ActivateBoosterResponse> | undefined, b: ActivateBoosterResponse | PlainMessage<ActivateBoosterResponse> | undefined): boolean {
    return proto3.util.equals(ActivateBoosterResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSolidPaymentFormRequest
 */
export class GetSolidPaymentFormRequest extends Message<GetSolidPaymentFormRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 1;
   */
  package?: PackageIdentity;

  /**
   * @generated from field: string payment_source = 2;
   */
  paymentSource = "";

  constructor(data?: PartialMessage<GetSolidPaymentFormRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSolidPaymentFormRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "package", kind: "message", T: PackageIdentity },
    { no: 2, name: "payment_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSolidPaymentFormRequest {
    return new GetSolidPaymentFormRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSolidPaymentFormRequest {
    return new GetSolidPaymentFormRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSolidPaymentFormRequest {
    return new GetSolidPaymentFormRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSolidPaymentFormRequest | PlainMessage<GetSolidPaymentFormRequest> | undefined, b: GetSolidPaymentFormRequest | PlainMessage<GetSolidPaymentFormRequest> | undefined): boolean {
    return proto3.util.equals(GetSolidPaymentFormRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetSolidPaymentFormResponse
 */
export class GetSolidPaymentFormResponse extends Message<GetSolidPaymentFormResponse> {
  /**
   * @generated from field: string merchant = 1;
   */
  merchant = "";

  /**
   * @generated from field: string signature = 2;
   */
  signature = "";

  /**
   * @generated from field: string payment_intent = 3;
   */
  paymentIntent = "";

  constructor(data?: PartialMessage<GetSolidPaymentFormResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetSolidPaymentFormResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "merchant", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_intent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSolidPaymentFormResponse {
    return new GetSolidPaymentFormResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSolidPaymentFormResponse {
    return new GetSolidPaymentFormResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSolidPaymentFormResponse {
    return new GetSolidPaymentFormResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSolidPaymentFormResponse | PlainMessage<GetSolidPaymentFormResponse> | undefined, b: GetSolidPaymentFormResponse | PlainMessage<GetSolidPaymentFormResponse> | undefined): boolean {
    return proto3.util.equals(GetSolidPaymentFormResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.PayByCardIDRequest
 */
export class PayByCardIDRequest extends Message<PayByCardIDRequest> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity package = 2;
   */
  package?: PackageIdentity;

  /**
   * @generated from field: string payment_source = 3;
   */
  paymentSource = "";

  constructor(data?: PartialMessage<PayByCardIDRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PayByCardIDRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "package", kind: "message", T: PackageIdentity },
    { no: 3, name: "payment_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayByCardIDRequest {
    return new PayByCardIDRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayByCardIDRequest {
    return new PayByCardIDRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayByCardIDRequest {
    return new PayByCardIDRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PayByCardIDRequest | PlainMessage<PayByCardIDRequest> | undefined, b: PayByCardIDRequest | PlainMessage<PayByCardIDRequest> | undefined): boolean {
    return proto3.util.equals(PayByCardIDRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.PayByCardIDResponse
 */
export class PayByCardIDResponse extends Message<PayByCardIDResponse> {
  /**
   * @generated from oneof gdx.gateway.web.payment.v2.PayByCardIDResponse.after_action
   */
  afterAction: {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.PayByCardIDResponse.StripeAction action = 1;
     */
    value: PayByCardIDResponse_StripeAction;
    case: "action";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PayByCardIDResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PayByCardIDResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "action", kind: "message", T: PayByCardIDResponse_StripeAction, oneof: "after_action" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayByCardIDResponse {
    return new PayByCardIDResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayByCardIDResponse {
    return new PayByCardIDResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayByCardIDResponse {
    return new PayByCardIDResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PayByCardIDResponse | PlainMessage<PayByCardIDResponse> | undefined, b: PayByCardIDResponse | PlainMessage<PayByCardIDResponse> | undefined): boolean {
    return proto3.util.equals(PayByCardIDResponse, a, b);
  }
}

/**
 * Describes stripe after action params to confirm payment.
 *
 * @generated from message gdx.gateway.web.payment.v2.PayByCardIDResponse.StripeAction
 */
export class PayByCardIDResponse_StripeAction extends Message<PayByCardIDResponse_StripeAction> {
  /**
   * @generated from field: string client_secret = 1;
   */
  clientSecret = "";

  constructor(data?: PartialMessage<PayByCardIDResponse_StripeAction>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.PayByCardIDResponse.StripeAction";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayByCardIDResponse_StripeAction {
    return new PayByCardIDResponse_StripeAction().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayByCardIDResponse_StripeAction {
    return new PayByCardIDResponse_StripeAction().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayByCardIDResponse_StripeAction {
    return new PayByCardIDResponse_StripeAction().fromJsonString(jsonString, options);
  }

  static equals(a: PayByCardIDResponse_StripeAction | PlainMessage<PayByCardIDResponse_StripeAction> | undefined, b: PayByCardIDResponse_StripeAction | PlainMessage<PayByCardIDResponse_StripeAction> | undefined): boolean {
    return proto3.util.equals(PayByCardIDResponse_StripeAction, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetBillingHistoryRequest
 */
export class GetBillingHistoryRequest extends Message<GetBillingHistoryRequest> {
  /**
   * @generated from field: string billing_from = 1;
   */
  billingFrom = "";

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<GetBillingHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetBillingHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "billing_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingHistoryRequest {
    return new GetBillingHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingHistoryRequest {
    return new GetBillingHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingHistoryRequest {
    return new GetBillingHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingHistoryRequest | PlainMessage<GetBillingHistoryRequest> | undefined, b: GetBillingHistoryRequest | PlainMessage<GetBillingHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingHistoryRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetBillingHistoryResponse
 */
export class GetBillingHistoryResponse extends Message<GetBillingHistoryResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.BillingHistoryItem history_items = 1;
   */
  historyItems: BillingHistoryItem[] = [];

  constructor(data?: PartialMessage<GetBillingHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetBillingHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "history_items", kind: "message", T: BillingHistoryItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingHistoryResponse {
    return new GetBillingHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingHistoryResponse {
    return new GetBillingHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingHistoryResponse {
    return new GetBillingHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingHistoryResponse | PlainMessage<GetBillingHistoryResponse> | undefined, b: GetBillingHistoryResponse | PlainMessage<GetBillingHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingHistoryResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.UnsubscribePremiumRequest
 */
export class UnsubscribePremiumRequest extends Message<UnsubscribePremiumRequest> {
  constructor(data?: PartialMessage<UnsubscribePremiumRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.UnsubscribePremiumRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnsubscribePremiumRequest {
    return new UnsubscribePremiumRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnsubscribePremiumRequest {
    return new UnsubscribePremiumRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnsubscribePremiumRequest {
    return new UnsubscribePremiumRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnsubscribePremiumRequest | PlainMessage<UnsubscribePremiumRequest> | undefined, b: UnsubscribePremiumRequest | PlainMessage<UnsubscribePremiumRequest> | undefined): boolean {
    return proto3.util.equals(UnsubscribePremiumRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.UnsubscribePremiumResponse
 */
export class UnsubscribePremiumResponse extends Message<UnsubscribePremiumResponse> {
  constructor(data?: PartialMessage<UnsubscribePremiumResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.UnsubscribePremiumResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnsubscribePremiumResponse {
    return new UnsubscribePremiumResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnsubscribePremiumResponse {
    return new UnsubscribePremiumResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnsubscribePremiumResponse {
    return new UnsubscribePremiumResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnsubscribePremiumResponse | PlainMessage<UnsubscribePremiumResponse> | undefined, b: UnsubscribePremiumResponse | PlainMessage<UnsubscribePremiumResponse> | undefined): boolean {
    return proto3.util.equals(UnsubscribePremiumResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.CancelPremiumRequest
 */
export class CancelPremiumRequest extends Message<CancelPremiumRequest> {
  constructor(data?: PartialMessage<CancelPremiumRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.CancelPremiumRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPremiumRequest {
    return new CancelPremiumRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPremiumRequest {
    return new CancelPremiumRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPremiumRequest {
    return new CancelPremiumRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPremiumRequest | PlainMessage<CancelPremiumRequest> | undefined, b: CancelPremiumRequest | PlainMessage<CancelPremiumRequest> | undefined): boolean {
    return proto3.util.equals(CancelPremiumRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.CancelPremiumResponse
 */
export class CancelPremiumResponse extends Message<CancelPremiumResponse> {
  constructor(data?: PartialMessage<CancelPremiumResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.CancelPremiumResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPremiumResponse {
    return new CancelPremiumResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPremiumResponse {
    return new CancelPremiumResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPremiumResponse {
    return new CancelPremiumResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPremiumResponse | PlainMessage<CancelPremiumResponse> | undefined, b: CancelPremiumResponse | PlainMessage<CancelPremiumResponse> | undefined): boolean {
    return proto3.util.equals(CancelPremiumResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPopUpPromoPackagesRequest
 */
export class ListPopUpPromoPackagesRequest extends Message<ListPopUpPromoPackagesRequest> {
  constructor(data?: PartialMessage<ListPopUpPromoPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPopUpPromoPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPopUpPromoPackagesRequest {
    return new ListPopUpPromoPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPopUpPromoPackagesRequest {
    return new ListPopUpPromoPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPopUpPromoPackagesRequest {
    return new ListPopUpPromoPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPopUpPromoPackagesRequest | PlainMessage<ListPopUpPromoPackagesRequest> | undefined, b: ListPopUpPromoPackagesRequest | PlainMessage<ListPopUpPromoPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListPopUpPromoPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPopUpPromoPackagesResponse
 */
export class ListPopUpPromoPackagesResponse extends Message<ListPopUpPromoPackagesResponse> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PromoType promo_type = 2;
   */
  promoType = PromoType.INVALID;

  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage packages = 3;
   */
  packages: PremiumPackage[] = [];

  constructor(data?: PartialMessage<ListPopUpPromoPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPopUpPromoPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "promo_type", kind: "enum", T: proto3.getEnumType(PromoType) },
    { no: 3, name: "packages", kind: "message", T: PremiumPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPopUpPromoPackagesResponse {
    return new ListPopUpPromoPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPopUpPromoPackagesResponse {
    return new ListPopUpPromoPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPopUpPromoPackagesResponse {
    return new ListPopUpPromoPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPopUpPromoPackagesResponse | PlainMessage<ListPopUpPromoPackagesResponse> | undefined, b: ListPopUpPromoPackagesResponse | PlainMessage<ListPopUpPromoPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListPopUpPromoPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPromoCreditsPackagesRequest
 */
export class ListPromoCreditsPackagesRequest extends Message<ListPromoCreditsPackagesRequest> {
  constructor(data?: PartialMessage<ListPromoCreditsPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPromoCreditsPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPromoCreditsPackagesRequest {
    return new ListPromoCreditsPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPromoCreditsPackagesRequest {
    return new ListPromoCreditsPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPromoCreditsPackagesRequest {
    return new ListPromoCreditsPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPromoCreditsPackagesRequest | PlainMessage<ListPromoCreditsPackagesRequest> | undefined, b: ListPromoCreditsPackagesRequest | PlainMessage<ListPromoCreditsPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListPromoCreditsPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPromoCreditsPackagesResponse
 */
export class ListPromoCreditsPackagesResponse extends Message<ListPromoCreditsPackagesResponse> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.PromoType promo_type = 2;
   */
  promoType = PromoType.INVALID;

  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.CreditsPackage packages = 3;
   */
  packages: CreditsPackage[] = [];

  constructor(data?: PartialMessage<ListPromoCreditsPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPromoCreditsPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "promo_type", kind: "enum", T: proto3.getEnumType(PromoType) },
    { no: 3, name: "packages", kind: "message", T: CreditsPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPromoCreditsPackagesResponse {
    return new ListPromoCreditsPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPromoCreditsPackagesResponse {
    return new ListPromoCreditsPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPromoCreditsPackagesResponse {
    return new ListPromoCreditsPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPromoCreditsPackagesResponse | PlainMessage<ListPromoCreditsPackagesResponse> | undefined, b: ListPromoCreditsPackagesResponse | PlainMessage<ListPromoCreditsPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListPromoCreditsPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPaymentMethodsRequest
 */
export class ListPaymentMethodsRequest extends Message<ListPaymentMethodsRequest> {
  constructor(data?: PartialMessage<ListPaymentMethodsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPaymentMethodsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPaymentMethodsRequest {
    return new ListPaymentMethodsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPaymentMethodsRequest {
    return new ListPaymentMethodsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPaymentMethodsRequest {
    return new ListPaymentMethodsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPaymentMethodsRequest | PlainMessage<ListPaymentMethodsRequest> | undefined, b: ListPaymentMethodsRequest | PlainMessage<ListPaymentMethodsRequest> | undefined): boolean {
    return proto3.util.equals(ListPaymentMethodsRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListPaymentMethodsResponse
 */
export class ListPaymentMethodsResponse extends Message<ListPaymentMethodsResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PaymentMethod payment_methods = 1;
   */
  paymentMethods: PaymentMethod[] = [];

  constructor(data?: PartialMessage<ListPaymentMethodsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListPaymentMethodsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_methods", kind: "message", T: PaymentMethod, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPaymentMethodsResponse {
    return new ListPaymentMethodsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPaymentMethodsResponse {
    return new ListPaymentMethodsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPaymentMethodsResponse {
    return new ListPaymentMethodsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPaymentMethodsResponse | PlainMessage<ListPaymentMethodsResponse> | undefined, b: ListPaymentMethodsResponse | PlainMessage<ListPaymentMethodsResponse> | undefined): boolean {
    return proto3.util.equals(ListPaymentMethodsResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPaymentMethodRequest
 */
export class GetPaymentMethodRequest extends Message<GetPaymentMethodRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentMethodType payment_method_type = 1;
   */
  paymentMethodType = PaymentMethodType.INVALID;

  constructor(data?: PartialMessage<GetPaymentMethodRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPaymentMethodRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_method_type", kind: "enum", T: proto3.getEnumType(PaymentMethodType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentMethodRequest {
    return new GetPaymentMethodRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentMethodRequest {
    return new GetPaymentMethodRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentMethodRequest {
    return new GetPaymentMethodRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentMethodRequest | PlainMessage<GetPaymentMethodRequest> | undefined, b: GetPaymentMethodRequest | PlainMessage<GetPaymentMethodRequest> | undefined): boolean {
    return proto3.util.equals(GetPaymentMethodRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetPaymentMethodResponse
 */
export class GetPaymentMethodResponse extends Message<GetPaymentMethodResponse> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PaymentMethod payment_method = 1;
   */
  paymentMethod?: PaymentMethod;

  constructor(data?: PartialMessage<GetPaymentMethodResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetPaymentMethodResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_method", kind: "message", T: PaymentMethod },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPaymentMethodResponse {
    return new GetPaymentMethodResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPaymentMethodResponse {
    return new GetPaymentMethodResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPaymentMethodResponse {
    return new GetPaymentMethodResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPaymentMethodResponse | PlainMessage<GetPaymentMethodResponse> | undefined, b: GetPaymentMethodResponse | PlainMessage<GetPaymentMethodResponse> | undefined): boolean {
    return proto3.util.equals(GetPaymentMethodResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ChangeSubscriptionPackageRequest
 */
export class ChangeSubscriptionPackageRequest extends Message<ChangeSubscriptionPackageRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PackageIdentity next_package = 1;
   */
  nextPackage?: PackageIdentity;

  constructor(data?: PartialMessage<ChangeSubscriptionPackageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ChangeSubscriptionPackageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "next_package", kind: "message", T: PackageIdentity },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPackageRequest {
    return new ChangeSubscriptionPackageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPackageRequest {
    return new ChangeSubscriptionPackageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPackageRequest {
    return new ChangeSubscriptionPackageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPackageRequest | PlainMessage<ChangeSubscriptionPackageRequest> | undefined, b: ChangeSubscriptionPackageRequest | PlainMessage<ChangeSubscriptionPackageRequest> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPackageRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ChangeSubscriptionPackageResponse
 */
export class ChangeSubscriptionPackageResponse extends Message<ChangeSubscriptionPackageResponse> {
  constructor(data?: PartialMessage<ChangeSubscriptionPackageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ChangeSubscriptionPackageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeSubscriptionPackageResponse {
    return new ChangeSubscriptionPackageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeSubscriptionPackageResponse {
    return new ChangeSubscriptionPackageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeSubscriptionPackageResponse {
    return new ChangeSubscriptionPackageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeSubscriptionPackageResponse | PlainMessage<ChangeSubscriptionPackageResponse> | undefined, b: ChangeSubscriptionPackageResponse | PlainMessage<ChangeSubscriptionPackageResponse> | undefined): boolean {
    return proto3.util.equals(ChangeSubscriptionPackageResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListOffboardingPackagesRequest
 */
export class ListOffboardingPackagesRequest extends Message<ListOffboardingPackagesRequest> {
  /**
   * @generated from field: gdx.gateway.web.payment.v2.PromoType promo_type = 1;
   */
  promoType = PromoType.INVALID;

  constructor(data?: PartialMessage<ListOffboardingPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListOffboardingPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "promo_type", kind: "enum", T: proto3.getEnumType(PromoType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOffboardingPackagesRequest {
    return new ListOffboardingPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOffboardingPackagesRequest {
    return new ListOffboardingPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOffboardingPackagesRequest {
    return new ListOffboardingPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListOffboardingPackagesRequest | PlainMessage<ListOffboardingPackagesRequest> | undefined, b: ListOffboardingPackagesRequest | PlainMessage<ListOffboardingPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListOffboardingPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListOffboardingPackagesResponse
 */
export class ListOffboardingPackagesResponse extends Message<ListOffboardingPackagesResponse> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage packages = 2;
   */
  packages: PremiumPackage[] = [];

  constructor(data?: PartialMessage<ListOffboardingPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListOffboardingPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "packages", kind: "message", T: PremiumPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOffboardingPackagesResponse {
    return new ListOffboardingPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOffboardingPackagesResponse {
    return new ListOffboardingPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOffboardingPackagesResponse {
    return new ListOffboardingPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListOffboardingPackagesResponse | PlainMessage<ListOffboardingPackagesResponse> | undefined, b: ListOffboardingPackagesResponse | PlainMessage<ListOffboardingPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListOffboardingPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListLimitedOfferPackagesRequest
 */
export class ListLimitedOfferPackagesRequest extends Message<ListLimitedOfferPackagesRequest> {
  constructor(data?: PartialMessage<ListLimitedOfferPackagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListLimitedOfferPackagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLimitedOfferPackagesRequest {
    return new ListLimitedOfferPackagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLimitedOfferPackagesRequest {
    return new ListLimitedOfferPackagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLimitedOfferPackagesRequest {
    return new ListLimitedOfferPackagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListLimitedOfferPackagesRequest | PlainMessage<ListLimitedOfferPackagesRequest> | undefined, b: ListLimitedOfferPackagesRequest | PlainMessage<ListLimitedOfferPackagesRequest> | undefined): boolean {
    return proto3.util.equals(ListLimitedOfferPackagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.ListLimitedOfferPackagesResponse
 */
export class ListLimitedOfferPackagesResponse extends Message<ListLimitedOfferPackagesResponse> {
  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.PremiumPackage premium_packages = 1;
   */
  premiumPackages: PremiumPackage[] = [];

  /**
   * @generated from field: repeated gdx.gateway.web.payment.v2.CreditsPackage credit_packages = 2;
   */
  creditPackages: CreditsPackage[] = [];

  constructor(data?: PartialMessage<ListLimitedOfferPackagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.ListLimitedOfferPackagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "premium_packages", kind: "message", T: PremiumPackage, repeated: true },
    { no: 2, name: "credit_packages", kind: "message", T: CreditsPackage, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLimitedOfferPackagesResponse {
    return new ListLimitedOfferPackagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLimitedOfferPackagesResponse {
    return new ListLimitedOfferPackagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLimitedOfferPackagesResponse {
    return new ListLimitedOfferPackagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListLimitedOfferPackagesResponse | PlainMessage<ListLimitedOfferPackagesResponse> | undefined, b: ListLimitedOfferPackagesResponse | PlainMessage<ListLimitedOfferPackagesResponse> | undefined): boolean {
    return proto3.util.equals(ListLimitedOfferPackagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SetPreferredPaymentCardRequest
 */
export class SetPreferredPaymentCardRequest extends Message<SetPreferredPaymentCardRequest> {
  /**
   * @generated from field: string card_id = 1;
   */
  cardId = "";

  constructor(data?: PartialMessage<SetPreferredPaymentCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SetPreferredPaymentCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "card_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetPreferredPaymentCardRequest {
    return new SetPreferredPaymentCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetPreferredPaymentCardRequest {
    return new SetPreferredPaymentCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetPreferredPaymentCardRequest {
    return new SetPreferredPaymentCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetPreferredPaymentCardRequest | PlainMessage<SetPreferredPaymentCardRequest> | undefined, b: SetPreferredPaymentCardRequest | PlainMessage<SetPreferredPaymentCardRequest> | undefined): boolean {
    return proto3.util.equals(SetPreferredPaymentCardRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SetPreferredPaymentCardResponse
 */
export class SetPreferredPaymentCardResponse extends Message<SetPreferredPaymentCardResponse> {
  constructor(data?: PartialMessage<SetPreferredPaymentCardResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SetPreferredPaymentCardResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetPreferredPaymentCardResponse {
    return new SetPreferredPaymentCardResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetPreferredPaymentCardResponse {
    return new SetPreferredPaymentCardResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetPreferredPaymentCardResponse {
    return new SetPreferredPaymentCardResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetPreferredPaymentCardResponse | PlainMessage<SetPreferredPaymentCardResponse> | undefined, b: SetPreferredPaymentCardResponse | PlainMessage<SetPreferredPaymentCardResponse> | undefined): boolean {
    return proto3.util.equals(SetPreferredPaymentCardResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetCreditsBalanceRequest
 */
export class GetCreditsBalanceRequest extends Message<GetCreditsBalanceRequest> {
  constructor(data?: PartialMessage<GetCreditsBalanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetCreditsBalanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditsBalanceRequest {
    return new GetCreditsBalanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditsBalanceRequest {
    return new GetCreditsBalanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditsBalanceRequest {
    return new GetCreditsBalanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditsBalanceRequest | PlainMessage<GetCreditsBalanceRequest> | undefined, b: GetCreditsBalanceRequest | PlainMessage<GetCreditsBalanceRequest> | undefined): boolean {
    return proto3.util.equals(GetCreditsBalanceRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetCreditsBalanceResponse
 */
export class GetCreditsBalanceResponse extends Message<GetCreditsBalanceResponse> {
  /**
   * @generated from field: int64 credits_count = 1;
   */
  creditsCount = protoInt64.zero;

  /**
   * @generated from field: bool is_autorefill_allowed = 2;
   */
  isAutorefillAllowed = false;

  /**
   * @generated from field: bool is_autorefill_enabled = 3;
   */
  isAutorefillEnabled = false;

  /**
   * @generated from field: int64 free_gifts_count = 4;
   */
  freeGiftsCount = protoInt64.zero;

  /**
   * @generated from field: bool display_autorefill_promo = 5;
   */
  displayAutorefillPromo = false;

  constructor(data?: PartialMessage<GetCreditsBalanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetCreditsBalanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credits_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "is_autorefill_allowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_autorefill_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "free_gifts_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "display_autorefill_promo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCreditsBalanceResponse {
    return new GetCreditsBalanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCreditsBalanceResponse {
    return new GetCreditsBalanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCreditsBalanceResponse {
    return new GetCreditsBalanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCreditsBalanceResponse | PlainMessage<GetCreditsBalanceResponse> | undefined, b: GetCreditsBalanceResponse | PlainMessage<GetCreditsBalanceResponse> | undefined): boolean {
    return proto3.util.equals(GetCreditsBalanceResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SetCreditsAutorefillRequest
 */
export class SetCreditsAutorefillRequest extends Message<SetCreditsAutorefillRequest> {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled = false;

  constructor(data?: PartialMessage<SetCreditsAutorefillRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SetCreditsAutorefillRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetCreditsAutorefillRequest {
    return new SetCreditsAutorefillRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetCreditsAutorefillRequest {
    return new SetCreditsAutorefillRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetCreditsAutorefillRequest {
    return new SetCreditsAutorefillRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetCreditsAutorefillRequest | PlainMessage<SetCreditsAutorefillRequest> | undefined, b: SetCreditsAutorefillRequest | PlainMessage<SetCreditsAutorefillRequest> | undefined): boolean {
    return proto3.util.equals(SetCreditsAutorefillRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.SetCreditsAutorefillResponse
 */
export class SetCreditsAutorefillResponse extends Message<SetCreditsAutorefillResponse> {
  constructor(data?: PartialMessage<SetCreditsAutorefillResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SetCreditsAutorefillResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetCreditsAutorefillResponse {
    return new SetCreditsAutorefillResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetCreditsAutorefillResponse {
    return new SetCreditsAutorefillResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetCreditsAutorefillResponse {
    return new SetCreditsAutorefillResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetCreditsAutorefillResponse | PlainMessage<SetCreditsAutorefillResponse> | undefined, b: SetCreditsAutorefillResponse | PlainMessage<SetCreditsAutorefillResponse> | undefined): boolean {
    return proto3.util.equals(SetCreditsAutorefillResponse, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusRequest
 */
export class GetFreeCreditsFeaturesStatusRequest extends Message<GetFreeCreditsFeaturesStatusRequest> {
  constructor(data?: PartialMessage<GetFreeCreditsFeaturesStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFreeCreditsFeaturesStatusRequest {
    return new GetFreeCreditsFeaturesStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusRequest {
    return new GetFreeCreditsFeaturesStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusRequest {
    return new GetFreeCreditsFeaturesStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFreeCreditsFeaturesStatusRequest | PlainMessage<GetFreeCreditsFeaturesStatusRequest> | undefined, b: GetFreeCreditsFeaturesStatusRequest | PlainMessage<GetFreeCreditsFeaturesStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetFreeCreditsFeaturesStatusRequest, a, b);
  }
}

/**
 * @generated from message gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusResponse
 */
export class GetFreeCreditsFeaturesStatusResponse extends Message<GetFreeCreditsFeaturesStatusResponse> {
  /**
   * Free features availability counters list.
   *
   * @generated from field: repeated gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusResponse.MapFeature features = 1;
   */
  features: GetFreeCreditsFeaturesStatusResponse_MapFeature[] = [];

  constructor(data?: PartialMessage<GetFreeCreditsFeaturesStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "features", kind: "message", T: GetFreeCreditsFeaturesStatusResponse_MapFeature, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFreeCreditsFeaturesStatusResponse {
    return new GetFreeCreditsFeaturesStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusResponse {
    return new GetFreeCreditsFeaturesStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusResponse {
    return new GetFreeCreditsFeaturesStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFreeCreditsFeaturesStatusResponse | PlainMessage<GetFreeCreditsFeaturesStatusResponse> | undefined, b: GetFreeCreditsFeaturesStatusResponse | PlainMessage<GetFreeCreditsFeaturesStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetFreeCreditsFeaturesStatusResponse, a, b);
  }
}

/**
 * Create connection between feature type and counter.
 *
 * @generated from message gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusResponse.MapFeature
 */
export class GetFreeCreditsFeaturesStatusResponse_MapFeature extends Message<GetFreeCreditsFeaturesStatusResponse_MapFeature> {
  /**
   * Only credits features ( from FeatureType ) should be here.
   *
   * @generated from field: gdx.market.v1.FeatureType feature_type = 1;
   */
  featureType = FeatureType.INVALID;

  /**
   * How many free usages are available.
   *
   * @generated from field: uint32 free_count = 2;
   */
  freeCount = 0;

  constructor(data?: PartialMessage<GetFreeCreditsFeaturesStatusResponse_MapFeature>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.GetFreeCreditsFeaturesStatusResponse.MapFeature";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "feature_type", kind: "enum", T: proto3.getEnumType(FeatureType) },
    { no: 2, name: "free_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFreeCreditsFeaturesStatusResponse_MapFeature {
    return new GetFreeCreditsFeaturesStatusResponse_MapFeature().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusResponse_MapFeature {
    return new GetFreeCreditsFeaturesStatusResponse_MapFeature().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFreeCreditsFeaturesStatusResponse_MapFeature {
    return new GetFreeCreditsFeaturesStatusResponse_MapFeature().fromJsonString(jsonString, options);
  }

  static equals(a: GetFreeCreditsFeaturesStatusResponse_MapFeature | PlainMessage<GetFreeCreditsFeaturesStatusResponse_MapFeature> | undefined, b: GetFreeCreditsFeaturesStatusResponse_MapFeature | PlainMessage<GetFreeCreditsFeaturesStatusResponse_MapFeature> | undefined): boolean {
    return proto3.util.equals(GetFreeCreditsFeaturesStatusResponse_MapFeature, a, b);
  }
}

